import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { Link } from 'modules/UI';

import NavBar from '../NavBar';

export const Container = styled.header`
  position: sticky;
  top: 0px;
  width: 100%;
  z-index: 2;
  background-color: ${tokens.colors.white};
  display: none;

  ${tokens.mediaQueries.s} {
    display: block;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  padding: ${tokens.space.small} ${tokens.space.regular};
`;

export const LeftContent = styled.div`
  justify-self: start;
`;

export const RightContent = styled.div`
  justify-self: end;
`;

export const LogoLink = styled(Link)`
  justify-self: center;
`;

export const NavLinkList = styled(NavBar)`
  border-top: 1px solid ${tokens.colors.grayLight};
  border-bottom: 1px solid ${tokens.colors.grayLight};
  display: flex;
  justify-content: center;
  overflow-x: auto;
`;
